export default __webpack_public_path__ + "static/neat_defence-min-c7e5f2234b07c3537286bb3d37b30bd7.png";